<script>
import { Bar } from "vue-chartjs";
import User from "../../apiClient/User";

require("./RoundedBar");

export default {
  extends: Bar,
  name: "BarChart",
  data(){
    return {
      totalIncomeExpenses: []
    }
  },
  methods: {
    getIngresosEgresos() {
      const months = [ "Ene", "Feb", "Mar", "Abr", "May", "Jun", 
           "Jul", "Ago", "Sep", "Oct", "Nov", "Dic" ];
      this.user.getTotalIncomeExpenses()
        .then(response => {
          if (response.status === 200) {
            let res = response.data.data;
            this.totalIncomeExpenses = res;
            let chartData = {
              labels: [],
              datasets: [
                {
                  label: "Egresos",
                  borderWidth: 0,
                  backgroundColor: "#E4527F",

                  data: [],
                  maxBarThickness: 20
                },
                {
                  label: "Ingresos",
                  borderWidth: 0,
                  backgroundColor: "#898DFF",
                  data: [],
                  maxBarThickness: 20
                }
              ]
            };

            for (let i = 0; i < this.totalIncomeExpenses.length; i++) {
              chartData.labels.push(months[parseInt(this.totalIncomeExpenses[i].mes) - 1]);
              chartData.datasets[0].data.push(this.totalIncomeExpenses[i].bajas);
              chartData.datasets[1].data.push(this.totalIncomeExpenses[i].altas);
            }

            this.renderChart(chartData, {
              responsive: true,
              maintainAspectRatio: false,
              cornerRadius: 4,
              scales: {
                xAxes: [
                  {
                    stacked: true,
                    gridLines: {
                      display: false
                    }
                  }
                ],
                yAxes: [
                  {
                    stacked: true,
                    ticks: {
                      stepSize: 10,
                      maxTicksLimit: 3
                    }
                  }
                ]
              },
              legend: {
                display: false
              },
              tooltips: {
                mode: 'label',
                bodySpacing: 6,
                itemSort: function(a, b) {
                  return b.datasetIndex - a.datasetIndex
                }
              }
            });
          }
        })
    }
  },
  mounted() {
    this.user = new User();
    this.getIngresosEgresos();
  }
};
</script>